import { jsx as t, Fragment as S, jsxs as R } from "react/jsx-runtime";
import { createContext as d, useMemo as v, useContext as m, useState as Y, useRef as j, useEffect as L } from "react";
import { b as k, C as $ } from "../packages/hydra-copilot/node_modules/streamdown/dist/chunk-BO2N2NFS.js";
import { mermaid as z } from "../node_modules/@streamdown/mermaid/dist/index.js";
import { Renderer as A } from "../node_modules/@openuidev/react-lang/dist/Renderer.js";
import "../node_modules/@openuidev/react-lang/dist/parser/types.js";
import "../node_modules/@openuidev/react-lang/dist/context.js";
import "../node_modules/@openuidev/react-lang/dist/hooks/useFormValidation.js";
import { useCopilotInstruction as F } from "./global-state.js";
const I = d(null), P = d(null), y = d(null);
function X({
  children: n,
  markdown: r,
  library: e,
  libraryPromptOptions: s,
  approvalComponent: i,
  mermaidComponent: p
}) {
  const a = v(() => {
    const { pre: o, code: h, ...U } = r ?? {}, C = { ...U }, b = o ?? _;
    C.pre = function({ children: u, ...l }) {
      const c = u?.props?.className ?? "";
      return c === "language-openui" || c === "language-mermaid" ? /* @__PURE__ */ t(S, { children: u }) : /* @__PURE__ */ t(b, { ...l, children: u });
    };
    const D = h ?? q;
    return C.code = function({ className: u, children: l, ...c }) {
      const w = typeof u == "string" ? u.replace("language-", "") : "", x = typeof l == "string" ? l : String(l ?? "");
      return w === "openui" && e != null ? /* @__PURE__ */ t(T, { code: x }) : w === "mermaid" ? /* @__PURE__ */ t(W, { code: x.replace(/\n$/, "") }) : /* @__PURE__ */ t(D, { ...c, className: u, children: l });
    }, C;
  }, [r, e]), f = v(() => {
    const o = e != null ? e.prompt({
      ...s,
      preamble: "When rendering UI, emit an `openui` code fence. Inside the fence, write valid openui-lang. Everything outside the fence is regular markdown."
    }) : null;
    return [
      "## Content Guidelines",
      "",
      "1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging.",
      "2. You can render diagrams using a `mermaid` code fence. Use this when visualizing flows, sequences, state machines, or relationships would help the user understand something better than prose alone. The diagram will be rendered interactively in the UI.",
      ...o != null ? [
        "3. You can also render rich UI components inline using an `openui` code fence. When you do, the fence content must be valid openui-lang — all syntax rules, component signatures, and streaming guidelines below apply to what goes inside the fence. Your prose outside the fence should remain standard markdown.",
        "",
        o
      ] : []
    ].join(`
`);
  }, [e, s]);
  F({ instruction: f });
  const g = v(() => ({ components: a }), [a]);
  return /* @__PURE__ */ t(I.Provider, { value: g, children: /* @__PURE__ */ t(P.Provider, { value: i ?? null, children: /* @__PURE__ */ t(y.Provider, { value: e ?? null, children: /* @__PURE__ */ t(M.Provider, { value: p ?? null, children: n }) }) }) });
}
function T({ code: n }) {
  const r = m(y), e = k();
  return r == null || n.trim() === "" ? null : /* @__PURE__ */ t(A, { response: n.trim(), library: r, isStreaming: e });
}
const M = d(null);
function W({ code: n }) {
  const r = k(), [e, s] = Y({ status: "idle" }), i = m(M), p = j(0);
  return L(() => {
    if (r)
      return;
    let a = !1;
    const f = `mermaid-${++p.current}-${Date.now()}`;
    async function g() {
      try {
        const o = z.getMermaid(), { svg: h } = await o.render(f, n);
        a || s({ status: "ok", svg: h, code: n });
      } catch (o) {
        a || s({
          status: "error",
          message: o instanceof Error ? o.message : "Failed to render diagram",
          code: n
        });
      }
    }
    return g(), () => {
      a = !0;
    };
  }, [n, r]), i != null ? /* @__PURE__ */ t(i, { result: e }) : e.status === "error" ? /* @__PURE__ */ R("pre", { style: { color: "red", fontSize: "0.85em" }, children: [
    "Mermaid Error: ",
    e.message
  ] }) : e.status !== "ok" ? null : /* @__PURE__ */ t("div", { dangerouslySetInnerHTML: { __html: e.svg } });
}
function Z() {
  return m(P);
}
function ee({
  children: n,
  isAnimating: r = !1,
  animated: e,
  rehypePlugins: s
}) {
  const i = m(I);
  if (i == null)
    throw new Error("Markdown must be used within CopilotProvider");
  return /* @__PURE__ */ t(
    $,
    {
      components: i.components,
      animated: e,
      isAnimating: r,
      rehypePlugins: s,
      children: n
    }
  );
}
function _(n) {
  return /* @__PURE__ */ t("pre", { ...n });
}
function q(n) {
  return /* @__PURE__ */ t("code", { ...n });
}
export {
  X as CopilotProvider,
  ee as Markdown,
  Z as useCopilotApproval
};
